import script from "./SovaClubFooter.vue?vue&type=script&setup=true&lang=ts"
export * from "./SovaClubFooter.vue?vue&type=script&setup=true&lang=ts"

import "./SovaClubFooter.vue?vue&type=style&index=0&id=12fb6372&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12fb6372"]])

export default __exports__